import Icon from 'veui/components/Icon'
import { IconFilterSolid } from 'dls-icons-vue'

Icon.register('filter-solid', IconFilterSolid)
